import {LeadAgentChangeNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {option, Option} from "ts-option";

/**
 * Agent change notification class data.
 */
export default class AgentChangeNotificationData {
	/**
	 *
	 * @param {string} leadId
	 * @param {string} referenceNumber
	 * @param {string} entity Entity from who assignee change originates.
	 * @param {Option<string>} previousAgentId id of the previous agent.
	 * @param {Option<string>} currentAgentId id of the current agent.
	 */
	constructor(readonly leadId: string,
		readonly referenceNumber: string,
		readonly entity: AuthenticatedEntity,
		readonly previousAgentId: Option<string>,
		readonly currentAgentId: Option<string>) {}

	static fromJson(json: LeadAgentChangeNotificationDataApiDto): AgentChangeNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new AgentChangeNotificationData(json.leadId, json.referenceNumber, creator, option(json.previousAgentId),
			option(json.currentAgentId));
	}

	getLeadReferenceNumber() {
		return this.referenceNumber;
	}
}